import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import clone from 'clone';
import reducers from '../reducers';
import {getItem, setItem} from '../module/LocalStorage';
import config from '../config/core.json';

export const configureStore = () => {

  // retrieve local storage existing data
  const LOCAL_STORAGE_KEY = config.localStorageKey;
  let existingData = {}, backedUpStagData;
  try {
    // retrieve the main blob of existing data
    existingData = JSON.parse(getItem(LOCAL_STORAGE_KEY) || "{}");

    // if we also have a backup of this stag's data individually, then overwrite the data with that
    if ( existingData && existingData.selectStag && existingData.selectStag.selected && existingData.selectStag.selected.stag ) {
      backedUpStagData = localStorage.getItem(LOCAL_STORAGE_KEY + "_" + existingData.selectStag.selected.stag);
      if ( backedUpStagData && backedUpStagData.length ) {
        backedUpStagData = JSON.parse(backedUpStagData);
        // update the code and the actual stag data
        existingData.selectStag.selected.code = backedUpStagData.code;
        existingData.data.data = {
          ...existingData.data.data,
          ...backedUpStagData.data,
        };
      }
    }
  } catch(err) {}

  // create the store
  const composeEnhancers = process.env.NODE_ENV !== "production" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  const store = createStore(
    reducers,
    existingData,
    composeEnhancers(applyMiddleware(thunk))
  );

  // back up store to local storage for offline handling
  store.subscribe(() => {
    const storeState = clone(store.getState(), false);
    storeState.application = {};
    storeState.admin.saving = {};
    storeState.user.authenticated = false;
    try {
      setItem(LOCAL_STORAGE_KEY, JSON.stringify(storeState));
      // back up stag data for stags that you've seen on this device
      if ( storeState.selectStag && storeState.selectStag.selected && storeState.data && storeState.data.data && storeState.data.data.homepage ) {
        setItem(LOCAL_STORAGE_KEY + "_" + storeState.selectStag.selected.stag, JSON.stringify({
          code: storeState.selectStag.selected.code,
          data: storeState.data.data,
        }));

        // also persist the code to stag mapping in local storage for offline retrieval
        if ( storeState.selectStag.selected.code && storeState.selectStag.selected.stag ) {
          setItem(LOCAL_STORAGE_KEY + "_CODE_" + storeState.selectStag.selected.code, storeState.selectStag.selected.stag);
        }
      }

    } catch(err) {}
  });

  return store;

};



// WEBPACK FOOTER //
// ./src/module/Store.js